import { ThankYouSvg } from "components/ThankYouSvg";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import Confetti from "react-confetti";
import { createUseStyles } from "react-jss";
import { Fragment } from "react/jsx-runtime";

export const ThankYouPage = () => {
  const classes = useStyles();

  const { scrollWidth: width, scrollHeight: height } = document.documentElement;

  const SOCIAL_BUTTONS = [
    {
      socialName: "Instagram",
      icon: "instagram",
      url: "https://social.dils.com/instagram/?utm_source=np-survey",
    },
    {
      socialName: "Facebook",
      icon: "facebook",
      url: "https://social.dils.com/facebook/?utm_source=np-survey",
    },
    {
      socialName: "Linkedin",
      icon: "linkedin",
      url: "https://social.dils.com/linkedin/?utm_source=np-survey",
    },
    {
      socialName: "Youtube",
      icon: "youtube",
      url: "https://social.dils.com/youtube/?utm_source=np-survey",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mx-0 mx-sm-auto my-5">
      <Confetti
        width={width}
        height={height}
        recycle={false}
        numberOfPieces={600}
        tweenDuration={4000}
      />
      <Card className={classes.noShadow}>
        <Card.Body style={{ height: "100%" }}>
          <div>
            <img
              src="/dils-logo.png"
              className={`mt-4 ${classes.dilsLogo}`}
              alt="Dils Logo"
            />

            <div className="mt-5"></div>

            <Fragment>
              <h2 className={`mb-4 ${classes.surveyTitle}`}>
                <ThankYouSvg />
                La tua opinione <span className={classes.dilsRed}>conta</span>
              </h2>
            </Fragment>
          </div>

          <div className="text-start mb-5">
            <div>Grazie per averci dedicato il tuo tempo</div>
            <div>Il team Dils ti ringrazia e augura buona giornata.</div>
          </div>

          <div className="text-start mt-5">
            <strong>Seguici sui social per rimanere sempre aggiornato.</strong>
          </div>

          <div className="text-start">
            {SOCIAL_BUTTONS.map((social, idx) => (
              <motion.div whileTap={{ scale: 0.98 }}>
                <a
                  href={social.url}
                  key={`${social}-${idx}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div
                    className={`d-flex align-items-center ${classes.socialButton}`}
                  >
                    <i className={`lab la-${social.icon} me-2 la-lg`} />
                    <strong>{social.socialName}</strong>
                  </div>
                </a>
              </motion.div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

const useStyles = createUseStyles({
  dilsLogo: {
    maxWidth: 150,
  },
  dilsRed: {
    color: "#e73838",
  },
  surveyTitle: {
    marginTop: 30,
    marginBottom: 14,
    fontSize: 22,
  },
  socialButton: {
    backgroundColor: "#e73838",
    fontSize: 18,
    fontWeight: 400,
    padding: "10px 15px",
    // border:"2px solid #e73838",
    color: "#FFF",
    borderRadius: 10,
    margin: "15px 0",
  },
  noShadow: {
    boxShadow: "none!important",
  },
});
